import moment from "moment";
import "moment/locale/nl";
import "moment/locale/de";
import "moment/locale/fr";
import "moment/locale/es";
import "moment/locale/pt";
import "moment/locale/pl";
import i18n from "../i18n";

moment.locale(i18n.global.locale.value);

export default moment;
